import React, { useMemo } from "react";

import { AIRBASE_PROPERTY_URL } from "../../utils/constants";

export const BookingTitle = ({ thread, property, isMultiplat = false }) => {
  const platformListingLink = useMemo(() => {
    const listingName = thread?.listing?.name;

    const platformUrl =
      thread?.listing?.id && !isMultiplat
        ? `https://www.airbnb.com/rooms/${thread.listing.id}`
        : null;

    if (!listingName) {
      return null;
    }

    if (!platformUrl) {
      return <span className="BookingDetails__listing">{listingName} -</span>;
    }

    return (
      <a
        className="BookingDetails__listing"
        href={platformUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {listingName} –
      </a>
    );
  }, [thread, isMultiplat]);

  const airbasePropertyLink = useMemo(() => {
    if (!property) {
      return "No property found";
    }

    const { id, home_code } = property;
    return (
      <a
        className="BookingDetails__listing"
        href={`${AIRBASE_PROPERTY_URL}/${id}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {home_code}
      </a>
    );
  }, [property]);

  const podAndLocality = useMemo(() => {
    const locality = property?.locality?.name;
    const pod = property?.pod?.name;

    return `(${[locality, pod].filter(Boolean).join(" - ")})`;
  }, [property]);

  return (
    <p className="BookingDetails__listing header" data-testid="listing-name">
      {platformListingLink} {airbasePropertyLink} {podAndLocality}
    </p>
  );
};
